export default "__VITE_ASSET__Cv5Cp5IK__"